import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2, Loader2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";

const inputCls = "w-full bg-[#181C28] border border-[#262B3D] rounded-xl px-4 py-3.5 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors";

export const ApplicationForm = ({ testidPrefix = "application" }) => {
  const [form, setForm] = useState({ name: "", email: "", situation: "regie", tjm: "", probleme: "" });
  const [state, setState] = useState({ loading: false, done: false, error: "" });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, done: false, error: "" });
    try {
      await api.post("/applications", {
        ...form,
        tjm: form.tjm ? parseInt(form.tjm, 10) : null,
      });
      setState({ loading: false, done: true, error: "" });
    } catch (err) {
      setState({ loading: false, done: false, error: formatApiError(err) });
    }
  };

  if (state.done) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        data-testid={`${testidPrefix}-success`}
        className="glass-card p-10 text-center"
      >
        <CheckCircle2 className="w-12 h-12 text-primary mx-auto mb-4" />
        <h3 className="font-heading text-2xl font-bold mb-2">Candidature envoyée</h3>
        <p className="text-slate-400 text-sm max-w-md mx-auto">
          Simon lit chaque candidature personnellement. Si ton profil colle à l'accompagnement,
          tu reçois un lien pour réserver ton appel découverte sous 48h.
        </p>
      </motion.div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`${testidPrefix}-form`} className="glass-card p-6 sm:p-8 space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Prénom & nom</label>
          <input required value={form.name} onChange={set("name")} placeholder="Jean Dupont" data-testid={`${testidPrefix}-name-input`} className={inputCls} />
        </div>
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Email</label>
          <input required type="email" value={form.email} onChange={set("email")} placeholder="jean@freelance.fr" data-testid={`${testidPrefix}-email-input`} className={inputCls} />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Ta situation</label>
          <select value={form.situation} onChange={set("situation")} data-testid={`${testidPrefix}-situation-select`} className={inputCls}>
            <option value="regie">En régie, activité qui tourne</option>
            <option value="intercontrat">En intercontrat / transition</option>
            <option value="demarrage">Je lance mon activité</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">TJM actuel (€)</label>
          <input type="number" min="0" value={form.tjm} onChange={set("tjm")} placeholder="550" data-testid={`${testidPrefix}-tjm-input`} className={inputCls} />
        </div>
      </div>
      <div>
        <label className="block text-xs font-mono uppercase tracking-widest text-slate-400 mb-2">Ton principal blocage aujourd'hui</label>
        <textarea required rows={4} value={form.probleme} onChange={set("probleme")} placeholder="Ex : je dépends d'une seule ESN, mon TJM n'a pas bougé en 2 ans…" data-testid={`${testidPrefix}-probleme-input`} className={`${inputCls} resize-none`} />
      </div>
      <button
        type="submit"
        disabled={state.loading}
        data-testid={`${testidPrefix}-submit-button`}
        className="group w-full inline-flex items-center justify-center gap-2 bg-primary text-[#0A0C10] font-semibold px-7 py-4 rounded-full transition-all duration-300 hover:bg-[#00C885] hover:shadow-[0_0_30px_rgba(0,229,153,0.35)] disabled:opacity-60"
      >
        {state.loading ? <Loader2 className="w-4 h-4 animate-spin" /> : (
          <>Envoyer ma candidature <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" /></>
        )}
      </button>
      {state.error && <p data-testid={`${testidPrefix}-error`} className="text-sm text-red-400 text-center">{state.error}</p>}
      <p className="text-xs text-slate-500 text-center">Réservé aux freelances dont l'activité est déjà lancée. Réponse sous 48h.</p>
    </form>
  );
};
